/**
 * 七鱼客服工具
 * 仅在 H5 环境下使用
 */

// #ifdef H5
import { useUserStore } from '@/store';

// 扩展 Window 类型
declare global {
  interface Window {
    ysf?: any;
  }
}

/** 七鱼 AppKey */
const QIYU_APP_KEY = '6f18ba8c22fb7335232cbfd5db68cf59';

/** 七鱼 SDK 是否已加载 */
let isQiyuLoaded = false;

/**
 * 加载七鱼 SDK
 */
const loadQiyuSDK = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (isQiyuLoaded && window.ysf) {
      resolve();
      return;
    }

    // 初始化 ysf 队列
    window.ysf =
      window.ysf ||
      function () {
        (window.ysf.q = window.ysf.q || []).push(arguments);
      };

    const script = document.createElement('script');
    script.async = true;
    // hidden=1 可以隐藏默认的悬浮按钮
    script.src = `https://qiyukf.com/script/${QIYU_APP_KEY}.js?hidden=1`;
    script.onload = () => {
      isQiyuLoaded = true;
      resolve();
    };
    script.onerror = () => {
      reject(new Error('七鱼 SDK 加载失败'));
    };
    document.body.appendChild(script);
  });
};

/**
 * 初始化七鱼客服配置
 */
const initConfig = () => {
  if (!window.ysf) return;

  const userStore = useUserStore();
  const userInfo = userStore.userInfo;

  // 基础配置
  const config: Record<string, any> = {
    // 自定义样式模板ID（在七鱼后台配置）
    templateId: 8143005,
    // 聊天窗口标题
    title: '在线客服',
    groupid: 583621889, // 心愿商场客服组
  };

  // 用户信息（如果已登录）
  if (userStore.isLogin && userInfo) {
    config.uid = userInfo.id; // 用户ID
    config.name = userInfo.lastName || '微信用户'; // 用户昵称
    config.mobile = userInfo.phoneNumber || ''; // 手机号
    config.email = userInfo.email || '';
    // 自定义字段（用于客服后台展示）
    config.data = JSON.stringify([
      { key: 'real_name', value: userInfo.lastName || '' },
      { key: 'mobile_phone', value: userInfo.phoneNumber || '' },
      { key: 'user_id', value: userInfo.id || '' },
      { key: 'avatar', label: '头像', value: userInfo.customFields?.headPortrait || '' },
    ]);
  }

  window.ysf('config', config);
};

/**
 * 打开客服聊天窗口
 */
const open = () => {
  if (!window.ysf) {
    console.warn('[七鱼] SDK 未加载');
    return;
  }
  window.ysf('open');
};

/**
 * 隐藏悬浮按钮
 */
const hideFloatIcon = () => {
  if (!window.ysf) return;
  window.ysf('hideFloatIcon');
};

/**
 * 显示悬浮按钮
 */
const showFloatIcon = () => {
  if (!window.ysf) return;
  window.ysf('showFloatIcon');
};

/**
 * 用户登出（清除用户信息）
 */
const logoff = () => {
  if (!window.ysf) return;
  window.ysf('logoff');
};

/**
 * 更新用户信息（登录后调用）
 */
const updateUserInfo = () => {
  if (!window.ysf) return;
  initConfig();
};

export default {
  loadQiyuSDK,
  initConfig,
  open,
  hideFloatIcon,
  showFloatIcon,
  logoff,
  updateUserInfo,
};
// #endif

